export default {
  mobile: 'Mobile',
  submit: 'Submit',
  pleaseTryAgain: 'Please try again',
  view: 'View',
  delete: 'Delete',
  no: 'No',
  yes: 'Yes',
  nothingFound: 'Nothing found!',
  nothingAdded: 'Nothing added',
  pressEnterToSelect: 'Press Enter to select',
  pressEnterToRemove: 'Press Enter to remove',
  selected: 'Selected',
  choose: 'Choose',
  more: 'More',
  less: 'Less',
  start: 'Start',
  resume: 'Resume',
  infoOf_: '{title} information',
  address: 'Address',
  car: 'Car',
  row: 'Row',
  and: 'and',
  type: 'Type',
  plateTemplate: '{right} {character} {left} - IRAN {iran}',
  other: 'Other',
  description: 'Description',
  attachments: 'Attachments',
  attachment: 'Attachment',
  image: 'Image',
  cancel: 'Cancel',
  save: 'Save',
  back: 'Back',
  creationTime: 'Creation time',
  routeTo: 'Route to {destination}',
  callTo: 'Call to {person}',
  undrestand: 'Undrestand',
  price: 'price',
  driverFeeAmount: 'Driver transportation fee',
  farePerPoint: 'Fare per point',
  trash: 'trash',
  material: 'material',
  toman: 'toman',
  title: 'Title',
  count: 'Count',
  status: 'Status',
  dateAndTime: 'Date and time',
  edit: 'Edit',
  filter: 'Filter',
  confirm: 'Confirm',
  selectAll: 'Select all',
  courier: 'Courier',
  startDate: 'Start date',
  endDate: 'End date',
  open: 'Open',
  fromStartToEnd: 'from {start} to {end}',
  noAddress: 'No address',
  noData: 'No data existed',
  skipDestination: 'Failed deliver',
  accept: 'Accept'
}
